/* Wallhush PDP v6 (white). Hero = self-playing muted problem->solution video loop (poster fallback); no scroll-triggered animation (Markus 01.10).
   html.static (?static=1 or reduced motion) = end-state still, no animation. */
(function () {
  'use strict';
  window.__whReady = 1;
  var root = document.documentElement;
  /* hero loop needs no GSAP: it plays unless ?static=1 or reduced motion, even if the 6 s CDN fallback flipped html to static */
  var MOTION = !(/[?&]static=1/.test(location.search) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches));
  var ANIM = root.classList.contains('anim') && typeof window.gsap !== 'undefined';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- toast + checkout placeholder ---------- */
  var toast = $('.toast'), tt;
  function say(msg) { toast.textContent = msg; toast.classList.add('show'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('show'); }, 2600); }


  /* ---------- HERO: self-playing muted loop (problem -> solution dramatization). Poster stays if the video can't play. ---------- */
  var vid = $('.loop-vid');
  if (MOTION && vid) {
    var base = vid.getAttribute(window.matchMedia('(max-width:600px)').matches ? 'data-m' : 'data-d'), inView = true;
    var play = function () { var p = vid.play(); if (p && p.catch) p.catch(function () {}); };
    vid.addEventListener('playing', function () { vid.classList.add('on'); }, { once: true });
    var start = function () { vid.src = base; vid.muted = true; if (inView) play(); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        inView = es[0].isIntersecting;
        if (!vid.getAttribute('src')) return;
        if (inView) play(); else vid.pause();
      }).observe(vid.parentNode);
    }
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  }

  /* ---------- PLAN: bundles 1 / 3 / 6 + quantity stepper, one price table ---------- */
  /* PRICING:start
     PROPOSED quantity-break prices (placeholders pending Markus's sign-off; every price element carries data-proposed).
     Per-unit price by quantity: 1 = $59.99 · 2 = $49.99 · 3–5 = $44.99 · 6–9 = $39.99 · 10+ = $34.99.
     "You save" is a real comparison with the $59.99 single-unit price, not a former / strike-through price.
     Money is kept in integer cents so totals never drift. */
  var WH_TIERS = [{ min: 1, max: 1, c: 5999 }, { min: 2, max: 2, c: 4999 }, { min: 3, max: 5, c: 4499 }, { min: 6, max: 9, c: 3999 }, { min: 10, max: Infinity, c: 3499 }];
  var WH_SINGLE = 5999, WH_MIN = 1, WH_MAX = 50;
  function whClamp(n) { n = Math.floor(+n); return isFinite(n) ? Math.min(WH_MAX, Math.max(WH_MIN, n)) : WH_MIN; }
  function whPrice(n) {
    n = whClamp(n);
    var i = 0; while (!(n >= WH_TIERS[i].min && n <= WH_TIERS[i].max)) i++;
    var each = WH_TIERS[i].c, total = n * each;
    return { n: n, tier: i, eachC: each, totalC: total, saveC: n * WH_SINGLE - total };
  }
  function whMoney(c) { return '$' + (Math.floor(c / 100)).toLocaleString('en-US') + '.' + ('0' + (c % 100)).slice(-2); }
  /* PRICING:end */
  window.WHPrice = { price: whPrice, money: whMoney, clamp: whClamp };

  var bundles = $$('.bd'), qtyIn = $('#qty'), stepBtns = $$('.st-b'), tierRows = $$('.tiers tr[data-tier]');
  var ogA = $('[data-og]'), ogB = $('[data-og2]'), ogC = $('[data-ogc]');
  var eachEl = $('[data-each]'), totalEl = $('[data-total]'), saveEl = $('[data-save]'), qLabel = $('[data-qlabel]'), buy = $('[data-buy]');
  var finalCta = $('[data-final-cta]'), bbLabel = $('[data-bb-label]'), bbPrice = $('[data-bb-price]'), bbCta = $('[data-bb-cta]');
  var front = ogA, back = ogB, thumbs = $$('.tb'), current = 3;
  var qtyHint = $('#qtyHint'), HINT = qtyHint.textContent;
  var units = function (n) { return n + (n === 1 ? ' unit' : ' units'); };
  function showImg(img, alt) {
    if (img === front.getAttribute('src')) { front.alt = alt; return; }
    back.loading = 'eager'; back.src = img;
    var swap = function () { back.onload = null; back.style.opacity = 1; front.style.opacity = 0; back.alt = alt; back.removeAttribute('aria-hidden'); front.alt = ''; front.setAttribute('aria-hidden', 'true'); var t = front; front = back; back = t; };
    if (back.complete && back.naturalWidth) swap(); else back.onload = swap;
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.toggle('on', x === t); });
      showImg(t.getAttribute('data-full'), t.querySelector('img').alt);
    });
  });
  var PACK_ALT = { 1: 'One Wallhush unit', 3: 'Three Wallhush units, the 3-pack', 6: 'Six Wallhush units, the 6-pack' };
  function setQty(n, opts) {
    opts = opts || {};
    var p = whPrice(n); n = p.n;
    if (!opts.typing) qtyIn.value = String(n);
    stepBtns[0].disabled = n <= WH_MIN; stepBtns[1].disabled = n >= WH_MAX;
    var match = null;
    bundles.forEach(function (b) { var on = +b.getAttribute('data-qty') === n; b.classList.toggle('sel', on); b.querySelector('input').checked = on; if (on) match = b; });
    tierRows.forEach(function (r) { r.classList.toggle('on', +r.getAttribute('data-tier') === p.tier); });
    var each = whMoney(p.eachC), tot = whMoney(p.totalC), save = whMoney(p.saveC);
    eachEl.textContent = each; eachEl.setAttribute('data-proposed', (p.eachC / 100).toFixed(2));
    totalEl.textContent = tot; totalEl.setAttribute('data-proposed', (p.totalC / 100).toFixed(2));
    qLabel.textContent = units(n);
    if (p.saveC > 0) { saveEl.textContent = 'You save ' + save + ' vs single-unit price'; saveEl.setAttribute('data-proposed', (p.saveC / 100).toFixed(2)); saveEl.classList.remove('nudge'); }
    else { saveEl.textContent = 'Add a second unit and pay ' + whMoney(whPrice(2).eachC) + ' each'; saveEl.setAttribute('data-proposed', '49.99'); saveEl.classList.add('nudge'); }
    buy.textContent = 'Get ' + units(n) + ' — ' + tot; buy.setAttribute('data-qty', n);
    if (finalCta) finalCta.textContent = buy.textContent;
    var nx = n < WH_MAX ? whPrice(n + 1) : null;   /* tier edge: 10 units cost less in total than 9 */
    qtyHint.textContent = nx && nx.totalC <= p.totalC ? 'Tip: ' + units(n + 1) + ' cost ' + whMoney(nx.totalC) + ', less than ' + n + '.' : HINT;
    bbLabel.textContent = units(n); bbPrice.textContent = tot; bbPrice.setAttribute('data-proposed', (p.totalC / 100).toFixed(2)); bbCta.textContent = 'Get ' + units(n);
    /* no bundle photo for this exact number: show the largest pack below it and say so in the pill */
    var shown = n >= 6 ? 6 : n >= 3 ? 3 : 1;
    ogC.textContent = match ? units(n) + ' · ' + n + (n === 1 ? ' adapter' : ' adapters') : units(n) + ' · photo shows ' + shown;
    if (n !== current || opts.init) {
      var src = (window.WH_PACK || {})[shown];
      showImg(src, match ? PACK_ALT[n] : PACK_ALT[shown] + ' (you are choosing ' + n + ')');
      thumbs.forEach(function (t) { t.classList.remove('on'); });
      if (ANIM && match && !opts.typing) gsap.fromTo(match, { scale: 0.985 }, { scale: 1, duration: 0.5, ease: 'expo.out', clearProps: 'transform' });
    }
    current = n;
    $$('[data-checkout]').forEach(function (a) { a.setAttribute('href', checkoutUrl(n)); a.setAttribute('data-qty', n); });
  }
  var WH_TRACK = (function () {   /* ad + ClickMagick params from the landing URL, kept for the whole visit */
    var k = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'cmc_vid', 'cmc_adid'], q = new URLSearchParams(location.search), t = {};
    try { t = JSON.parse(sessionStorage.getItem('wh_track') || '{}'); } catch (e) {}
    k.forEach(function (n) { var v = q.get(n); if (v) t[n] = v.slice(0, 250); });
    try { sessionStorage.setItem('wh_track', JSON.stringify(t)); } catch (e) {}
    return t;
  })();
  function checkoutUrl(n) {
    n = whClamp(n); var v = (window.WH_VARIANTS || [])[whPrice(n).tier];
    if (!v) return '#buy';
    /* Shopify cart permalink: n units of the tier variant, straight to checkout. The ad params ride along as order
       attributes (visible on every Shopify order) and as plain params; ClickMagick's Shopify app reads its own cookie. */
    /* keys are prefixed 'ad_': cmc.js rewrites any [utm_source]/[gclid]/[cmc_vid] text inside links into its value */
    var u = new URLSearchParams(), cm = window.clickmagick_cmc; u.set('attributes[ad_landing_page]', 'wallhush-us');
    Object.keys(WH_TRACK).forEach(function (n) { u.set('attributes[ad_' + n + ']', WH_TRACK[n]); });
    if (cm && cm.vid) u.set('attributes[ad_cm_visitor]', cm.vid);   /* ClickMagick's own visitor id, for the Visitor Profile */
    return '/cart/' + v + ':' + n + '?' + u.toString();
  }
  bundles.forEach(function (b) { b.querySelector('input').addEventListener('change', function () { setQty(+b.getAttribute('data-qty')); }); });
  stepBtns.forEach(function (b) {
    b.addEventListener('click', function () { setQty(whClamp(qtyIn.value || current) + +b.getAttribute('data-step')); });
  });
  qtyIn.addEventListener('input', function () {
    var v = qtyIn.value.replace(/\D/g, '').slice(0, 2);
    if (v !== qtyIn.value) qtyIn.value = v;
    if (v === '') return;               /* let people clear the field and type a new number */
    var n = +v; if (n > WH_MAX) { qtyIn.value = String(WH_MAX); n = WH_MAX; }
    if (n < WH_MIN) return;             /* "0" mid-typing: wait for the next digit or blur */
    setQty(n, { typing: true });
  });
  qtyIn.addEventListener('blur', function () { setQty(qtyIn.value === '' ? current : +qtyIn.value); });
  qtyIn.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); setQty(whClamp(qtyIn.value || current) + (e.key === 'ArrowUp' ? 1 : -1)); }
    else if (e.key === 'Enter') { e.preventDefault(); setQty(qtyIn.value === '' ? current : +qtyIn.value); }
  });
  setQty(3, { init: true });

  /* every buy CTA (buy box, sticky bar, final offer) goes to checkout with the current stepper quantity (1–50) */
  function goCheckout(e) { e.preventDefault(); location.href = checkoutUrl(whClamp(qtyIn.value || current)); }
  $$('[data-checkout]').forEach(function (a) { a.addEventListener('click', goCheckout); });

  /* ---------- sticky buy bar (mobile) ---------- */
  var bar = $('[data-buybar]'), plan = $('#buy'), heroEl = $('.hero');
  function barCheck() {
    var y = window.scrollY, h = heroEl.getBoundingClientRect(), p = plan.getBoundingClientRect();
    var show = h.bottom < 0 && !(p.top < window.innerHeight * 0.85 && p.bottom > 0) && document.documentElement.scrollHeight - y - window.innerHeight > 200;
    bar.classList.toggle('show', show);
  }
  window.addEventListener('scroll', barCheck, { passive: true }); barCheck();

  if (!ANIM) return;

  /* ---------- magnetic CTAs (fine pointers only) ---------- */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $$('[data-mag]').forEach(function (b) {
      var qx = gsap.quickTo(b, 'x', { duration: 0.4, ease: 'power3.out' }), qy = gsap.quickTo(b, 'y', { duration: 0.4, ease: 'power3.out' });
      b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); qx((e.clientX - r.left - r.width / 2) * 0.22); qy((e.clientY - r.top - r.height / 2) * 0.32); });
      b.addEventListener('pointerleave', function () { qx(0); qy(0); });
    });
  }

  /* pause looping SVG/CSS animations while off screen */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('offscreen', !e.isIntersecting); }); }, { rootMargin: '100px' });
    $$('.how, .modes, #setup').forEach(function (el) { io.observe(el); });
  }

})();
